"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renameObjectKey = void 0;
function renameObjectKey(obj, newKeys) {
    const keyValues = Object.keys(obj).map((key) => {
        if (obj[key] === null || obj[key] === undefined) {
            return {};
        }
        const newKey = newKeys[key] || key;
        return { [newKey]: obj[key] };
    });
    return Object.assign({}, ...keyValues);
}
exports.renameObjectKey = renameObjectKey;
//# sourceMappingURL=objects.js.map